import { useState, useEffect } from 'react';
import { Progress } from 'react-vant';
import { formatScore } from 'utils/index';
import { _T } from '@dana/components';
import { FlowItem } from 'api/type';
import './level-rule';

const LevelProgress: React.FC<{
  close: () => void;
  value: number;
  data: FlowItem[] | undefined;
}> = ({ close, data, value }) => {
  const [tab, setTab] = useState(0);
  const [dList, setDlist] = useState<any>([[], [], [], []]);

  function chunkArray(array: any[], size: number) {
    let result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  useEffect(() => {
    let d: any = [];
    if (data) {
      d = chunkArray(data, 3);
    }
    setDlist(() => d);
  }, []);

  function getStyle(index: number) {
    if (tab === index) {
      return 'rounded-[16px] bg-white';
    }
    return '';
  }

  function changeTab(index: number) {
    setTab(index);
  }

  function getProgress(value1: number, value2: number) {
    return (value1 / value2) * 100 >= 100 ? 100 : (value1 / value2) * 100;
  }

  return (
    <div className="w-[295px] h-[349px] bg-white pt-[22px] rounded-[16px]">
      <div className="mx-auto text-center text-[#333] text-[18px] font-bold font-sans" dir="auto">
        {_T('收到的钻石')}
      </div>
      <div className="mx-auto mt-[12px] w-[246px] h-[38px] rounded-[31px] bg-[#F5F7F7] overflow-x-scroll pt-[3px]">
        <div
          className={`flex justify-start items-center`}
          style={{
            width: `${dList.length * 75}px`,
          }}
        >
          {dList.map((item: any[], index: number) => (
            <div
              key={index}
              onClick={() => changeTab(index)}
              className={`flex ml-[4px] w-[70px] h-[32px] justify-center items-center text-center text-[14px] font-bold bg-white rounded-[16px] font-sans ${tab === index ? 'text-[#16B28D]' : 'text-[#B3B3B3]'} ${getStyle(0)}`}
            >
              Lv.{index * 3}~{(index + 1) * 3}
            </div>
          ))}
        </div>
        {/* <div onClick={() => changeTab(0)} className={`w-[60px] h-[32px] flex justify-center items-center text-center text-[14px] font-bold font-sans ${tab === 0 ? 'text-[#16B28D]' : 'text-[#B3B3B3]'} ${getStyle(0)}`}>Lv.1~3</div>
            <div onClick={() => changeTab(1)} className={`w-[60px] h-[32px] flex justify-center items-center text-center text-[14px] font-bold font-sans ${tab === 1 ? 'text-[#16B28D]' : 'text-[#B3B3B3]'} ${getStyle(1)}`}>Lv.4~6</div>
            <div onClick={() => changeTab(2)} className={`w-[60px] h-[32px] flex justify-center items-center text-center text-[14px] font-bold font-sans ${tab === 2 ? 'text-[#16B28D]' : 'text-[#B3B3B3]'} ${getStyle(2)}`}>Lv.7~9</div>
            <div onClick={() => changeTab(3)} className={`w-[60px] h-[32px] flex justify-center items-center text-center text-[14px] font-bold font-sans ${tab === 3 ? 'text-[#16B28D]' : 'text-[#B3B3B3]'} ${getStyle(3)}`}>Lv.9~11</div> */}
      </div>
      {/* todo: lv 0 - 1 */}
      {dList[tab][0]?.flowTotal && (
        <div className="flex flex-col justify-center items-center w-full mt-[20px]">
          <div className="flex justify-between items-center w-[247px]">
            <div className="text-[#16B28D] text-[14px] font-bold leading-[18px] font-sans">
              Lv.{tab * 3}~Lv.{1 + tab * 3}(${dList[tab][0]?.salary})
            </div>
            <div className="flex justify-center items-center">
              <div
                className="w-[18px] h-[18px] bg-cover"
                style={{
                  backgroundImage: `url(${require('asset/imgs/coin.png')})`,
                }}
              ></div>
              <div className="text-right text-[#FFB627] font-sans text-[14px] font-bold">
                {value}/{formatScore(dList[tab][0]?.flowTotal)}
              </div>
            </div>
          </div>
          <div className="w-[247px] mt-[10px]">
            <Progress
              percentage={getProgress(value, dList[tab][0]?.flowTotal)}
              pivotText={''}
              color="linear-gradient(90deg, #7DD97F 0%, #16B28D 100%)"
            />
          </div>
        </div>
      )}
      {dList[tab][1]?.flowTotal && (
        <div className="flex flex-col justify-center items-center w-full mt-[20px]">
          <div className="flex justify-between items-center w-[247px]">
            <div className="text-[#16B28D] text-[14px] font-bold leading-[18px] font-sans">
              Lv.{tab * 3 + 1}~Lv.{2 + tab * 3}(${dList[tab][1]?.salary})
            </div>
            <div className="flex justify-center items-center">
              <div
                className="w-[18px] h-[18px] bg-cover"
                style={{
                  backgroundImage: `url(${require('asset/imgs/coin.png')})`,
                }}
              ></div>
              <div className="text-right text-[#FFB627] font-sans text-[14px] font-bold">
                {value}/{formatScore(dList[tab][1]?.flowTotal)}
              </div>
            </div>
          </div>
          <div className="w-[247px] mt-[10px]">
            <Progress
              percentage={getProgress(value, dList[tab][1]?.flowTotal)}
              pivotText={''}
              color="linear-gradient(90deg, #7DD97F 0%, #16B28D 100%)"
            />
          </div>
        </div>
      )}
      {dList[tab][2]?.flowTotal && (
        <div className="flex flex-col justify-center items-center w-full mt-[20px]">
          <div className="flex justify-between items-center w-[247px]">
            <div className="text-[#16B28D] text-[14px] font-bold leading-[18px] font-sans">
              Lv.{tab * 3 + 2}~Lv.{3 + tab * 3}(${dList[tab][2]?.salary})
            </div>
            <div className="flex justify-center items-center">
              <div
                className="w-[18px] h-[18px] bg-cover"
                style={{
                  backgroundImage: `url(${require('asset/imgs/coin.png')})`,
                }}
              ></div>
              <div className="text-right text-[#FFB627] font-sans text-[14px] font-bold">
                {value}/{formatScore(dList[tab][2]?.flowTotal)}
              </div>
            </div>
          </div>
          <div className="w-[247px] mt-[10px]">
            <Progress
              percentage={getProgress(value, dList[tab][2]?.flowTotal)}
              pivotText={''}
              color="linear-gradient(90deg, #7DD97F 0%, #16B28D 100%)"
            />
          </div>
        </div>
      )}
      <div
        onClick={() => close()}
        className="absolute bottom-[20px] left-[50%] translate-x-[-50%] mx-auto mt-[20px] flex justify-center items-center w-[191px] h-[44px] rounded-[74px] bg-gradient-to-r from-[#7DD97F] to-[#16B28D] text-white font-sans text-[16px] font-semibold"
      >
        {_T('确定')}
      </div>
    </div>
  );
};

export default LevelProgress;
